import React, {useEffect, useRef, useState} from 'react';
import casino from "../../_asset/media/casino.mp4"
import casino_bg from "../../_asset/media/casino.png"
import useInterval from "../../hooks/useInterval";

function CasinoVideo() {
    // const [video, setVideo] = useState<HTMLVideoElement | null>(null);
    //
    // useEffect(() => {
    //     const videoElement = document.getElementById("bg-video") as HTMLVideoElement;
    //     setVideo(videoElement);
    // }, []);
    //
    // useEffect(() => {
    //     if (video) {
    //         let lastTime = video.currentTime;
    //
    //         const intervalId = setInterval(() => {
    //             if (video.currentTime === lastTime) {
    //                 // 재생이 멈췄을 때 실행할 코드
    //                 console.log("비디오가 멈췄습니다.");
    //                 video.play()
    //             }
    //             lastTime = video.currentTime;
    //         }, 1000); // 1초마다 확인
    //
    //         return () => clearInterval(intervalId);
    //     }
    // }, [video]);

    const srcUrl = 'b6RFYhhw2bw'
    return (
        <div id={"global-video-background"}>
            {/* <iframe src={`https://www.youtube.com/embed/${srcUrl}?si=wf0qOJI_FuvoKzxr&controls=0&loop=1&playlist=${srcUrl}&autoplay=1&mute=1`}
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; loop; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen></iframe> */}
            {/* <div className={"background-cover"}></div> */}
        </div>
    );
}

export default CasinoVideo;